/**
 * The three ways an authored document leaves the app, as menu entries (MYAC-1162,
 * MYAC-1667). One list for the reader's Export menu and the library row's ⋮ menu, so
 * the two cannot drift into different labels, icons or order. Kept free of imports:
 * the row's menu reads it without pulling the export's stores along.
 */
export type AuthoredDocumentExportKind = 'pdf' | 'markdown' | 'copy'

export const AUTHORED_DOCUMENT_EXPORTS: readonly {
  kind: AuthoredDocumentExportKind
  labelKey: string
  icon: string
}[] = [
  { kind: 'pdf', labelKey: 'authoredDocuments.export.pdf', icon: 'pi pi-file-pdf' },
  { kind: 'markdown', labelKey: 'authoredDocuments.export.markdown', icon: 'pi pi-download' },
  { kind: 'copy', labelKey: 'authoredDocuments.export.copy', icon: 'pi pi-copy' },
]
